<template>
    <div>
        <el-form :model="formGet" status-icon ref="formGet" label-position="top" class="form-get" size="mini">

        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_category')" label-width="80px" prop="categoryListInput">
                    <el-select class="inputs" no-data-text="no data" v-model="formGet.categoryId" :placeholder="$t('settings_companyAdditionalInfo_selectCategory')" size="small" style="width: 100%;">
                        <el-option
                                v-for="item in formGet.categoryList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <!-- <el-form-item class="company-logo-block" label-position="left" :label="$t('settings_companyAdditionalInfo_companyLogo')" label-width="90px">
                    <el-upload
                            class="logo-uploader"
                            action=""
                            :show-file-list="false"
                            :http-request="handleLogoSuccess"
                            :before-upload="beforeLogoUpload">
                        <img v-if="formGet.logoUrl" :src="formGet.logoUrl" class="logo">
                        <i v-else class="el-icon-plus logo-uploader-icon"></i>
                    </el-upload>
                </el-form-item> -->
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_description')" label-width="80px" prop="briefDescription">
                    <el-input :placeholder="$t('settings_companyAdditionalInfo_briefDescription')" v-model="formGet.briefDescription"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_classification')" label-width="90px" prop="classification">
                    <el-select no-data-text="no data" v-model="formGet.classificationId" :placeholder="$t('settings_companyAdditionalInfo_selectClassification')" size="small"  style="width: 100%;">
                        <el-option
                                v-for="item in formGet.classificationList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_header')" label-width="80px" prop="reportHeader">
                    <el-input :placeholder="$t('settings_companyAdditionalInfo_reportHeader')" v-model="formGet.reportHeader"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_signatory')" label-width="90px" prop="companySignatory">
                    <el-input :placeholder="$t('settings_companyAdditionalInfo_companySignatory')" v-model="formGet.companySignatory"></el-input>
                </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_TINOfSignatory')" label-width="80px" prop="tinOfSignatory">
                    <el-input :placeholder="$t('settings_companyAdditionalInfo_TINOfSignatory')" v-model="formGet.tinOfSignatory"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item :label="$t('settings_companyAdditionalInfo_TitlePositionOfSignatory')" label-width="90px" prop="titlePositionOfSignatory">
                    <el-input :placeholder="$t('settings_companyAdditionalInfo_TitlePositionOfSignatory')" v-model="formGet.titlePositionOfSIgnatory"></el-input>
                </el-form-item>
            </el-col>
        </el-row>
            <el-form-item>
                <el-button @click="save('formGet')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
        </el-form>
        <createCompanyCategoryModal  @setNewCategory="setNewCategory" v-model="formGet.categoryListInput" ref="createCompanyCategoryModal"/>
        <createCompanyClassificationModal  @setNewClassification="setNewClassification" v-model="formGet.classificationListInput" ref="createCompanyClassificationModal"/>
    </div>
</template>

<script>
  import axios from 'axios'
  import createCompanyCategoryModal from '@/components/settings/companyCategories/createCompanyCategoryModal'
  import createCompanyClassificationModal from '@/components/settings/companyClassifications/createCompanyClassificationModal'
  export default {
    name: 'setting-company-additional-info',
    components: {
      createCompanyCategoryModal,
      createCompanyClassificationModal
    },
    computed: {},
    data() {
      return {
        formGet: {
          // companyId: '',
          categoryId: '',
          categoryList: [],
          categoryListInput:'',
          logoUrl: '',
          briefDescription: '',
          classificationId: '',
          classificationList: [],
          classificationListInput: '',
          reportHeader: '',
          companySignatory: '',
          tinOfSignatory: '',
          titlePositionOfSIgnatory:'',
        },
        links:[],
        isEmptyCategory:false,
        isEmptyClassification:false,
      }
    },
    methods:{
      async getCompanyAditionalInfo(tabName){
        let loader = this.$loading.show();
        await this.directories();
        await this.item();
        loader.hide()
      },
      directories(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/companies/directoriesCompanyAdditionalInfo?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log(response.data)
              this.formGet.categoryList = response.data.data.categories;
              this.formGet.classificationList = response.data.data.classes;
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      item(){
        return new Promise ((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/companies/itemCompanyAdditionalInfo?companyId=${this.$route.query.companyId}`)
            .then(response => {
              if(response.data.item){
                this.formGet.categoryId = response.data.item.categoryId;
                this.formGet.logoUrl = response.data.item.avatarUrl;
                this.formGet.classificationId = response.data.item.classifId;
                this.formGet.briefDescription = response.data.item.description;
                this.formGet.reportHeader = response.data.item.header;
                this.formGet.companySignatory = response.data.item.signatory;
                this.formGet.tinOfSignatory  = response.data.item.tinOfSignatory;
                this.formGet.titlePositionOfSIgnatory = response.data.item.titlePositionOfSignatory;
                console.log(response.data)
              }
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              reject(error)
            });
        });
      },
      querySearchCategory(queryString, cb){
        var links = this.formGet.categoryList;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmptyCategory = true
            this.formGet.categoryId = ''
          }else{
            this.isEmptyCategory = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmptyCategory = true
            }else if(val.name == queryString){
              this.isEmptyCategory = false
            }
          })
          if(this.formGet.categoryListInput === ''){
            this.isEmptyCategory = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      querySearchClassification(queryString, cb){
        console.log(queryString, {cb})
        // var links = this.links;
        var links = this.formGet.classificationList;
        var results = queryString ? links.filter(this.createFilter(queryString)) : links;
        // call callback function to return suggestion objects
        console.log(results)
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if(results.length < 1){
            this.isEmptyClassification = true
            this.formGet.classificationId = ''
          }else{
            this.isEmptyClassification = false
          }
          results.forEach(val => {
            if(val.name !== queryString){
              this.isEmptyClassification = true
            }else if(val.name == queryString){
              this.isEmptyClassification = false
            }
          })
          if(this.formGet.classificationListInput === ''){
            this.isEmptyClassification = false
          }
          console.log('results', results)
          cb(results);
        }, 500 * Math.random());
      },
      setNewCategory(newCategory){
        if(newCategory){
          this.formGet.categoryListInput = newCategory.name
          this.formGet.categoryId = newCategory.id
          this.isEmptyCategory = false
        }
      },
      setNewClassification(newClassification){
        if(newClassification){
          this.formGet.classificationListInput = newClassification.name
          this.formGet.classificationId = newClassification.id
          this.isEmptyClassification = false
        }
      },
      createFilter(queryString) {
        return (link) => {
          console.log('link', link)
          return (link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelectCategory(item) {
        this.formGet.categoryListInput = item.name
        this.formGet.categoryId = item.id
        this.isEmptyCategory = false
        console.log(item);
      },
      handleSelectClassification(item) {
        this.formGet.classificationListInput = item.name
        this.formGet.classificationId = item.id
        this.isEmptyClassification = false
        console.log(item);
      },
      handleIconClickCategory(ev) {
        console.log(ev);
        this.$refs['createCompanyCategoryModal'].openModal()
        this.$refs['createCompanyCategoryModal'].form.name = this.formGet.categoryListInput

        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
        //   .then(response => {
        //     console.log('---/companyVendors/directories', response.data);
        //     this.$refs['createCompanyCategoryModal'].openModal()
        //     // this.directories = response.data
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
      },
      handleIconClickClassification(ev) {
        this.$refs['createCompanyClassificationModal'].openModal()
        this.$refs['createCompanyClassificationModal'].form.name = this.formGet.classificationListInput

        // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        // axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        // axios
        //   .post(`/api/v1/companyVendors/directories?companyId=${this.$route.query.companyId}&operation=create`)
        //   .then(response => {
        //     console.log('---/companyVendors/directories', response.data);
        //     this.$refs['createCompanyCategoryModal'].openModal()
        //     // this.directories = response.data
        //   })
        //   .catch(error => {
        //     console.log('An error occurred:', error);
        //   });
      },
      save(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            const data = {
              categoryId: this.formGet.categoryId || null,
              logoUrl: this.formGet.logoUrl || null,
              classificationId: this.formGet.classificationId || null,
              briefDescription: this.formGet.briefDescription || null,
              reportHeader: this.formGet.reportHeader || null,
              companySignatory: this.formGet.companySignatory || null,
              tinOfSignatory: this.formGet.tinOfSignatory || null,
              titlePositionOfSIgnatory: this.formGet.titlePositionOfSIgnatory || null,
            };
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/companies/saveCompanyAdditionalInfo?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.$message({
                  type: 'success',
                  message: 'Company Additional Info Saved'
                });
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          }
        });
      },
      handleLogoSuccess( file, fileList ) {
        console.log("FILE",file);
        var formData = new FormData();
        formData.append('file', file.file);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/files/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
          .then(response => {
            console.log('---P', response.data);
            this.formGet.logoUrl = response.data.fileUrl;
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      beforeLogoUpload(file) {
        const isImage = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/tiff', 'image/webp'].indexOf(file.type) != -1;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isImage) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureMustBeJPGFormat'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('settings_companyAdditionalInfoError_AvatartPictureSizeCanNotExeed2MB'));
        }
        return isImage && isLt2M;
      },
    }
  }
</script>

<style lang="less" scoped>
    .form-get{
        width:700px;
    }
    .el-autocomplete{
        width:100%;
    }
    /deep/.logo-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    /deep/.logo-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    /deep/.logo-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        line-height: 70px !important;
        text-align: center;
    }
    /deep/.logo {
        width: 200px;
        /*height:70px;*/
        display: block;
    }
</style>
